<template>
  <v-container fluid fill-height>
    <v-layout row wrap>
      <v-flex xs12 v-if="tiposPagamento && tiposMaquineta">
        <pagamentos-extras></pagamentos-extras>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import { maquinetaDao } from '@/api'
import PagamentosExtras from '@/components/PagamentosExtras'

export default {
  components: {
    PagamentosExtras
  },
  data () {
    return {
    }
  },
  computed: {
    posto () {
      return this.$store.getters.posto
    },
    tiposMaquineta () {
      return this.$store.getters.tiposMaquineta
    },
    tiposPagamento () {
      return this.$store.getters.tiposPagamento
    }
  },
  watch: {
    posto (val) {
      if (val) {
        this.$store.dispatch('carregarTiposPagamento')
        this.$store.dispatch('carregarTiposMaquineta')
      }
    }
  },
  mounted () {
    if (this.posto) {
      this.$store.dispatch('carregarTiposPagamento')
      this.$store.dispatch('carregarTiposMaquineta')
    }
  }
}
</script>
